module.exports = __webpack_public_path__ + "static/media/Gendrome.b1ee3e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Gendrome.png
// module id = 110
// module chunks = 0